import { EmptyState } from '@/components/EmptyState'

export const EmptyStateSatpen = () => {
  return (
    <EmptyState
      title="Data tidak ditemukan"
      description="Tidak dapat menemukan data satuan pendidikan aktif, silahkan pilih satuan pendidikan lainnya"
      size="sm"
    />
  )
}
